import type { IGetHistoricoRegimeTributarioResponse } from "../requests/types";

export interface IFormaTributacaoHistorico {
  year: string;
  value: number;
}

export interface IFormaTributacao {
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  historico: IFormaTributacaoHistorico[];
}

export interface IDetalhesFormaTributacao {
  empresas: IFormaTributacao[];
}

export default class FormaTributacao {
  constructor(
    readonly response: IGetHistoricoRegimeTributarioResponse | undefined
  ) {}

  private handleHistorico(
    historico: Record<string, number> | undefined | null
  ): IFormaTributacaoHistorico[] {
    if (!historico) return [];

    return Object.entries(historico).map(([key, value]) => ({
      value: value,
      year: key
    }));
  }

  handler(): IFormaTributacao {
    return {
      nomeFantasia: this.response?.nomeFantasia || "-",
      razaoSocial: this.response?.razaoSocial || "-",
      cnpj: this.response?.cnpj.completo || "-",
      historico: this.handleHistorico(this.response?.historicoRegimeTributario)
    };
  }
}
